import { jsx as _jsx } from "react/jsx-runtime";
// Tooltip: shadcn/ui's Tooltip on @radix-ui/react-tooltip. It shows on hover and on keyboard focus
// of its trigger and hides on Escape. A tooltip repeats a name; it never holds the only copy of
// something the user needs (an icon button still has its own accessible name).
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cva } from "class-variance-authority";
import { useMemo, useState } from "react";
import { cn } from "./cn.js";
import { composeRefs, useLayerPart } from "./layer.js";
import { usePortalContainer } from "./portal.js";
export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipTrigger = TooltipPrimitive.Trigger;
/** A tooltip with its own provider, as shadcn/ui ships it, so one works without an app-wide provider. */
export function Tooltip({ delayDuration = 300, ...props }) {
    return (_jsx(TooltipPrimitive.Provider, { delayDuration: delayDuration, children: _jsx(TooltipPrimitive.Root, { ...props }) }));
}
const tooltipVariants = cva([
    "z-modal rounded-8 border border-wp-line-strong bg-wp-panel-2 font-sans leading-tight",
    "text-wp-text shadow-2",
], {
    variants: {
        compact: { false: "px-2 py-1 text-12", true: "px-1.5 py-0.5 text-11" },
    },
    defaultVariants: { compact: false },
});
export function TooltipContent({ className, compact, container, sideOffset = 6, ref, ...props }) {
    const target = usePortalContainer(container);
    // Opened from inside a popover, a press on it is a press inside that popover (layer.ts, LayerParts).
    const [node, setNode] = useState(null);
    useLayerPart(node);
    const contentRef = useMemo(() => composeRefs(ref, setNode), [ref]);
    if (target === null)
        return null; // the Surface root has not mounted yet: never the page's body
    return (_jsx(TooltipPrimitive.Portal, { container: target, children: _jsx(TooltipPrimitive.Content, { sideOffset: sideOffset, "data-compact": compact ?? false, className: cn(tooltipVariants({ compact }), className), ...props, ref: contentRef }) }));
}
//# sourceMappingURL=tooltip.js.map